import { Component, OnInit } from '@angular/core';
import {HelloWorldComponent} from '../hello-world/hello-world.component';
import {DateComponent} from '../date/date.component';
import { MaterialModule} from '../../material/material.module';


@Component({
    selector: 'training-part1',
    templateUrl: './training-part1.component.html',
    styleUrls: ['./training-part1.component.scss'],
    standalone: false
})
export class TrainingPart1Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
